var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0.75C14.0786 0.75 11.666 2.92873 11.2985 5.75L2 5.75C1.58579 5.75 1.25 6.08579 1.25 6.5C1.25 6.91421 1.58579 7.25 2 7.25L11.2985 7.25C11.666 10.0713 14.0786 12.25 17 12.25C20.1756 12.25 22.75 9.67564 22.75 6.5C22.75 3.32436 20.1756 0.75 17 0.75ZM12.75 6.5C12.75 4.15279 14.6528 2.25 17 2.25C19.3472 2.25 21.25 4.15279 21.25 6.5C21.25 8.84721 19.3472 10.75 17 10.75C14.6528 10.75 12.75 8.84721 12.75 6.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7015 16.25C12.334 13.4287 9.92145 11.25 7 11.25C3.82436 11.25 1.25 13.8244 1.25 17C1.25 20.1756 3.82436 22.75 7 22.75C9.92145 22.75 12.334 20.5713 12.7015 17.75H22C22.4142 17.75 22.75 17.4142 22.75 17C22.75 16.5858 22.4142 16.25 22 16.25L12.7015 16.25ZM2.75 17C2.75 14.6528 4.65279 12.75 7 12.75C9.34721 12.75 11.25 14.6528 11.25 17C11.25 19.3472 9.34721 21.25 7 21.25C4.65279 21.25 2.75 19.3472 2.75 17Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTune);
export default __webpack_public_path__ + "static/media/tune.a3f81015d0b9f13e5242439fcbbe71cf.svg";
export { ForwardRef as ReactComponent };